import PageContainer from '@/common/components/PageContainer'
import withUserPermission from '@/common/components/WithUserPermission'
import { PermissionType } from '@/common/types'
import { PermissionKeys } from '@/modules/manage-member/mappers'
import { useTablePagination } from '@/common/hooks/useTablePaginate'
import useQueryGetActivePlayer from '@/modules/manage-player/api/hooks/useQueryGetActivePlayer'
import ActivePlayerListing from '@/modules/manage-player/components/ActivePlayer/components/ActivePlayerListing'
import { useState, useEffect } from 'react'
import { useDateFilter } from '@/common/hooks/useDateFilter'
import { format, startOfDay, endOfDay } from 'date-fns'
import { useQueryState, parseAsString } from 'nuqs'

type SortOrder = 'asc' | 'desc' | undefined

function ActivePlayerListDirectPage() {
	const { pageSize, currentPage, searchQuery } = useTablePagination()
	const { dateFilter, setDateFilter } = useDateFilter()
	const [dateRange, setDateRange] = useQueryState(
		'dateRange',
		parseAsString.withDefault(''),
	)

	useEffect(() => {
		// Only set today's date if there are no dates AND dateRange is not 'all'
		if (!dateFilter.startDate && !dateFilter.endDate && dateRange !== 'all') {
			const today = new Date()
			setDateFilter({
				startDate: format(startOfDay(today), 'yyyy-MM-dd'),
				endDate: format(endOfDay(today), 'yyyy-MM-dd'),
			})
			setDateRange('today')
		}
	}, [
		dateFilter.startDate,
		dateFilter.endDate,
		dateRange,
		setDateFilter,
		setDateRange,
	])

	const [betAmountSort, setBetAmountSort] = useState<SortOrder>()
	const [depositAmountSort, setDepositAmountSort] = useState<SortOrder>('desc')
	const [withdrawAmountSort, setWithdrawAmountSort] = useState<SortOrder>()
	const handleSort = (columnId: string, order: SortOrder) => {
		if (columnId === 'totalBetAmount') {
			setBetAmountSort(order)
			setDepositAmountSort(undefined)
		} else if (columnId === 'totalDepositAmount') {
			setDepositAmountSort(order)
			setBetAmountSort(undefined)
		} else if (columnId === 'totalWithdrawAmount') {
			setWithdrawAmountSort(order)
			setDepositAmountSort(undefined)
		}
	}

	const payload = {
		take: pageSize,
		skip: (currentPage - 1) * pageSize,
		phone: searchQuery,
		startDate: dateFilter.startDate || undefined,
		endDate: dateFilter.endDate || undefined,
		betAmountSort,
		depositAmountSort,
		withdrawAmountSort,
	}

	const { data, isLoading } = useQueryGetActivePlayer(payload)

	return (
		<PageContainer>
			<ActivePlayerListing
				data={data?.data || []}
				total={data?.total || 0}
				isLoading={isLoading}
				onSort={handleSort}
				showBackButton={false}
			/>
		</PageContainer>
	)
}

const GuardedActivePlayerListDirectPage = withUserPermission(
	ActivePlayerListDirectPage,
	{
		permissionType: PermissionType.Read,
		permissionKey: [PermissionKeys.MANAGE_PLAYER],
	},
)

export default GuardedActivePlayerListDirectPage
